import moment from 'moment'
import { getLocalUser } from 'utils/localStorage'
import { getNameInitials } from 'utils/formatText'

export const eventTitle = (connection, translation, startTime) => {
  const user = getLocalUser()
  const userName = user?.firstName || getNameInitials(user)
  let connectionName = connection?.firstName || getNameInitials(connection)
  if (connection?.deletedAt) {
    connectionName = translation('contact.deletedUser', {
      firstName: connectionName
    })
  }
  return `${userName} / ${connectionName}${startTime ? ` - ${moment(startTime).format('dddd, MMMM DD')}` : ''}`
}

export const eventStarted = event =>
  moment.utc().add(5, 'minutes').isAfter(moment.utc(event.startTime))

export const eventEnded = (event, addedMins = 5) =>
  moment.utc().isAfter(moment.utc(event.endTime).add(addedMins, 'minutes'))
